export enum FinalLifeCycleStatus {
    Created,
    UnderReview,
    Approved,
    Rejected,
    Archived,
}
